const ebitdaScheduleResource = (() => {
    const _default_config = {
        slider: {
            min_value: 1.25,
            max_value: 2,
            step: 0.1,
        },
        TLPDefaults: {
            rate: 4,
            term: 5,
            payable: "Monthly"
        }
    };
    let slider1, slider2;
    const init = (default_config, resource, resource_config) => {
        Object.assign(_default_config, default_config);
        Object.assign(_default_config, resource_config);
        _default_config.resource = resource;
        _default_config.old_data = _default_config.data;
        appendHTML();
        templateEvents.updatedOnWindowResize(loadChart);
    };
    const appendHTML = () => {
        _default_config.current_range_value = _default_config.slider.min_value;
        _default_config.additional_range_value = _default_config.slider.min_value;
        _default_config.TLPDefaults = {
            rate: 4,
            term: 5,
            payable: "Monthly"
        };
        appendDSCRScheduleHTML();
    };

    /**
     * filterData : filtering data
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const filterData = () => {
        const html_config = [];
        for (let j = _default_config.quarter_filter_option.length - 1; j >= 0; --j) {
            html_config.push({
                "html": initScript.keyToCamelCaseWithUpperCaseString((_default_config.quarter_filter_option[j] === "half") ? "Bi-Annual" : _default_config.quarter_filter_option[j]),
                "config": { "value": _default_config.quarter_filter_option[j] }
            });
        }
        initScript.getHTMLElementByDelimiter("quarterFilterOption", "#").html(initScript.getCommonHTML(html_config, "option"));
    };

    const appendDSCRScheduleHTML = () => {
        initScript.getHTMLElementByDelimiter("ebitdaNumberOfMonths").html("Number of months: " + _default_config.bank_statement_info.dscr_schedule["no_of_months"]);
        _default_config.data = _default_config.bank_statement_info.dscr_schedule.report;
        const groups = ["Revenue", "Est. Operating Profit", "Debt Service", "DSCR"];
        for (let i = 0; i < _default_config.data.length; ++i) {
            const group = _default_config.data[i].group;
            _default_config[group] = {};
            _default_config.data[i].group = groups[i];
            if (i === 2 && !isNaN(_default_config.data[i][_default_config.quarter_filter_option[3]])) {
                _default_config.current_debt = _default_config.original.current_debt = typeCastedValue(_default_config.data[i][_default_config.quarter_filter_option[3]]);
                initScript.getHTMLElementByDom("debtService", "#").value = _default_config.current_debt;
                initScript.getHTMLElementByDom("debtService", "#").setAttribute("value", _default_config.current_debt);
            }
            if (i === 1 && !isNaN(_default_config.data[i][_default_config.quarter_filter_option[3]])) 
            {  
                _default_config.est_operating_profit = Number(_default_config.data[i][_default_config.quarter_filter_option[3]]);
                _default_config.est_operating_profit_object = _default_config.data[i];
            }
            for (let j = 0; j < _default_config.quarter_filter_option.length; ++j) {
                _default_config[group][_default_config.quarter_filter_option[j]] = 0;
                let _val = _default_config.data[i][_default_config.quarter_filter_option[j]];
                if (!isNaN(_val)) _default_config[group][_default_config.quarter_filter_option[j]] = _val = (i === 3) ? _val : typeCastedValue(_val);
            }
        }
        _default_config.columns = _default_config.body.config.dscr_schedule.columns;
        _default_config.rows = _default_config.body.config.dscr_schedule.rows;
        const headers = Object.keys(_default_config.body.config.dscr_schedule.columns);
        _default_config.table_divs = _default_config.DSCRSchedule;
        _default_config.table_divs[1].columns = initScript.removeUnexpectedElements(headers, ["group"]);
        templateUtil.appendTabelHeaders(_default_config);
        templateUtil.appendTabelRows(_default_config);
        appendEstOperatingProfitScheduleHTML();
    };

    function sortClassificationItems(data){
        data.expense.items = data.expense.items.sort(function (a, b) {
            if(a.name == b.name) return 0;
            if(a.name == "Net Transfer" || a.name == "Net Returns and Refunds"){
                return 1
            }
            if(b.name == "Net Transfer" || b.name == "Net Returns and Refunds"){
                return -1
            }
            return b.amount - a.amount; //DESC
        });
        data.revenue.items = data.revenue.items.sort(function (a, b) {
            return b.amount - a.amount; //DESC
        });
        data.debt.items = data.debt.items.sort(function (a, b) {
            return b.amount - a.amount; //DESC
        });
        return data;
    }

    const appendEstOperatingProfitScheduleHTML = () => {
        let JSONData = sortClassificationItems(_default_config.old_data);
        _default_config.columns = _default_config.est_operating_profit_schedule.columns;
        const headers = _default_config.est_operating_profit_schedule.headers;

        const keys = Object.keys(JSONData);

        let resp = [], obj = {}, keysTags = {"revenue":"Revenue", "expense":"Operating Expense", "debt": "Debt Service", "dscr_calculations": "DSCR Analysis"};
        let debtResp = [], dscrResp = [];
        _default_config.pre_sum = {};
        for (let i = 0; i < keys.length; ++i) {
            if (keys[i] === 'transfer') continue;
            _default_config.pre_sum[keys[i]] = [0];
            let hobj = {
                // classification: '<b>' + keys[i].replace(keys[i][0], keys[i][0].toUpperCase()) + '</b>',
                classification: '<b>' +keysTags[keys[i]]+ '</b>',
                group: '',
                'average_monthly_cash_flow ($)': "<b>" + initScript.separateNumberByCommaAndRoundOffwithSign(JSONData[keys[i]]['monthly_flow'], [3, ","], false) + '</b>',
                'annual_cash_flow ($)': "<b>" + initScript.separateNumberByCommaAndRoundOffwithSign(JSONData[keys[i]]['annual_flow'], [3, ","], false) + "</b>"
            };
            if(keys[i] === "debt") debtResp.push(hobj) //remove if and keep else to bring debt back to left
            else if(keys[i] === "dscr_calculations") {}//dscrResp.push(hobj)
            else resp.push(hobj)
            for (let j = 0; j < JSONData[keys[i]]['items'].length; ++j) {
                _default_config.pre_sum[keys[i]].push(_default_config.pre_sum[keys[i]][_default_config.pre_sum[keys[i]].length - 1] + JSONData[keys[i]]['items'][j].amount);
                obj = {};
                obj['classification'] = JSONData[keys[i]]['items'][j]['name'];
                obj['group'] = JSONData[keys[i]]['items'][j]['group'];
                obj['average_monthly_cash_flow ($)'] = initScript.separateNumberByCommaAndRoundOffwithSign(JSONData[keys[i]]['items'][j]['monthly_flow'], [3, ","], false);
                obj['annual_cash_flow ($)'] = initScript.separateNumberByCommaAndRoundOffwithSign(JSONData[keys[i]]['items'][j]['annual_flow'], [3, ","], false);
                if(keys[i] === "debt") debtResp.push(obj) //remove if and keep else to bring debt back to left
                else if(keys[i] === "dscr_calculations") {
                    if(obj["classification"] == "Net Taxes"){
                        dscrResp.push({
                            "classification": "<h4>Net Taxes</h4>",
                            "group": "",
                            'average_monthly_cash_flow ($)': "",
                            'annual_cash_flow ($)': ""
                        })
                    }
                    if("Est. Operating Profit" == obj["classification"]) {
                        var objCP = JSON.parse(JSON.stringify(obj));
                        objCP["classification"] = "<b>"+objCP["classification"]+"</b>";
                        objCP["group"] = "";
                        objCP['average_monthly_cash_flow ($)'] = "<b>"+objCP["average_monthly_cash_flow ($)"]+"</b>";
                        objCP['annual_cash_flow ($)'] = "<b>"+objCP["annual_cash_flow ($)"]+"</b>";
                        resp.push(objCP)
                    }
                    else if( "Est. Existing DSCR" == obj["classification"]) {
                        obj['average_monthly_cash_flow ($)'] = JSONData[keys[i]]['items'][j]['monthly_flow'];
                        obj['annual_cash_flow ($)'] = JSONData[keys[i]]['items'][j]['annual_flow'];        
                    }
                    dscrResp.push(obj)
                }
                else resp.push(obj)
            }
        }
        JSONData = resp;
        _default_config.data = templateUtil.getColumnWiseData(JSONData, headers);
        _default_config.headers = headers;
        _default_config.table_divs = [
            {
                "target": {
                    "header": "EstOperatingProfitScheduleHeader",
                    "row": "EstOperatingProfitScheduleRow"
                },
                "row_parent": {
                    "class": "row data-row"
                },
                "columns": headers
            }
        ];
        templateUtil.appendTabelHeaders(_default_config);
        templateUtil.appendTabelRows(_default_config);
        //separate Debt data on right side
        _default_config.data = templateUtil.getColumnWiseData(debtResp, headers);
        _default_config.table_divs = [
            {
                "target": {
                    "header": "debtServiceInOprHeader",
                    "row": "debtServiceInOprRow"
                },
                "row_parent": {
                    "class": "row data-row"
                },
                "columns": headers
            }
        ];
        templateUtil.appendTabelHeaders(_default_config);
        templateUtil.appendTabelRows(_default_config);
        dscrAccountLevel(dscrResp);
        //----------------
        appendAggregatedHTML();
    };

    const dscrAccountLevel = (dscrResp) => {
        var headers = ["classification", "average_monthly_cash_flow ($)", "annual_cash_flow ($)"]
        _default_config.table_divs = [
            {
                "target": {
                    "header": "dscrAccountLevelHeader",
                    "row": "dscrAccountLevelRow"
                },
                "row_parent": {
                    "class": "row data-row"
                },
                "columns": headers
            }
        ];        
        _default_config.data = templateUtil.getColumnWiseData(dscrResp, headers);

        templateUtil.appendTabelHeaders(_default_config);
        templateUtil.appendTabelRows(_default_config);        
    };

    const appendAggregatedHTML = () => {
        appendExistingDebtServiceHTML();
    };

    const appendExistingDebtServiceHTML = () => {
        const data = _default_config.old_data;
        _default_config.headers = ['classification', 'average_monthly_cash_flow', 'average_annual_cash_flow'];
        _default_config.data = [
            {
                classification: 'Est. Operating Profit ($)',
                'average_monthly_cash_flow': (data['revenue']['monthly_flow'] - data['expense']['monthly_flow']).toFixed(2),
                'average_annual_cash_flow': (data['revenue']['annual_flow'] - data['expense']['annual_flow']).toFixed(2),
            },
            {
                classification: 'Existing Debt Service ($)',
                'average_monthly_cash_flow': (data['debt']['monthly_flow']).toFixed(2),
                'average_annual_cash_flow': (data['debt']['annual_flow']).toFixed(2)
            },
            {
                classification: 'Est. Existing DSCR',
                'average_monthly_cash_flow': (((data['revenue']['monthly_flow'] - data['expense']['monthly_flow']) / (data['debt']['monthly_flow'] > 0 ? data['debt']['monthly_flow'] : 1))).toFixed(2),
                'average_annual_cash_flow': ''
            }
        ];
        
        if(_default_config.showExistingDebtServiceView){
            _default_config.data = templateUtil.getColumnWiseData(_default_config.data, _default_config.headers);
            _default_config.table_divs = _default_config.existing_debt_service.table_divs;
            _default_config.table_divs[0].columns = _default_config.headers;
            _default_config.columns = _default_config.existing_debt_service.columns;
            templateUtil.appendTabelHeaders(_default_config);
            templateUtil.appendTabelRows(_default_config);
        }
        else{
            $("#existingDebtServiceViewTab").hide();
        }
        appendDSCRCalculationsHTML();
    };
    const appendDSCRCalculationsHTML = () => {
        _default_config.data = _default_config.old_data;
        let gross_annual_revenue = _default_config['gross_annual_revenue'] ? _default_config['gross_annual_revenue'] : 0;
        gross_annual_revenue = Number(gross_annual_revenue.toString().trim().replace(/[,$]/gm, ''));
        _default_config.headers = ['annual_revenue', ''];
        _default_config.data = [
            {
                annual_revenue: 'Stated Revenue ($)',
                '': initScript.separateNumberByDelimiter(gross_annual_revenue, [3, ","], false)
            },
            {
                annual_revenue: 'Calculated Revenue ($)',
                '': initScript.separateNumberByDelimiter(_default_config.data['revenue']['annual_flow'], [3, ","], false)
            },
            {
                annual_revenue: 'Calculated % of Stated',
                '': (((Number(_default_config.data['revenue']['annual_flow']) - Number(gross_annual_revenue)) / (Number(_default_config.data['revenue']['annual_flow']) > 0 ? _default_config.data['revenue']['annual_flow'] : 1)) * 100).toFixed(2)
            }
        ];

        if(_default_config.dscrView){
            _default_config.table_divs = _default_config.dscr_calculations.table_divs;
            _default_config.data = templateUtil.getColumnWiseData(_default_config.data, _default_config.headers);
            _default_config.table_divs[0].columns = _default_config.headers;
            _default_config.columns = _default_config.dscr_calculations.columns;
            templateUtil.appendTabelHeaders(_default_config);
            templateUtil.appendTabelRows(_default_config);
        }
        else{
            $('#dscrCalculationsView').hide()
        }
        loadChart();
        filterData();
        initRangeBar();
        if(_default_config.tlp){
            appendTLPCalculationsHTML()
        }
        else {
            $('#TLPCalculations').hide()
        }

        // if(!_default_config.tlp && !_default_config.dscrView) $('#TLPCalculations').parent().prev().addClass("col-12").removeClass("col-6")
    };

    /**
     * appendTLPCalculationsHTML : getting bank-statement html through config file
     * @author Ahmad Zaman
     */
    const appendTLPCalculationsHTML = () => {
        let operatingProfit = _default_config.est_operating_profit_object[_default_config.selected_option];
        const current_debt = initScript.roundOff(Math.max(0, _default_config.current_debt));
        const current_debt_margin = initScript.roundOff(current_debt * _default_config.current_range_value - current_debt);
        var future_debt_value = initScript.roundOff(_default_config.future_debt / (_default_config.additional_range_value || 1));

        if( (current_debt+current_debt_margin) > operatingProfit){
            future_debt_value = 0;
        }
        
        var rate = _default_config.TLPDefaults.rate, term = _default_config.TLPDefaults.term
        var payable = _default_config.TLPDefaults.payable
        var divider = 12;
        if(payable == "Daily") divider = 365;
        else if(payable == "Weekly") divider = 52;
        else if(payable == "Bi-weekly") divider = 24;
        var TLPCalculations = {
            // "annualDebtCapacity" : _default_config.operating_profit.yearly,
            // "monthlyDebtCapacity" : (_default_config.operating_profit.yearly/12),
            "annualDebtCapacity" : future_debt_value,
            "monthlyDebtCapacity" : (future_debt_value/12),
            "annualRate": rate,
            "monthlyRate": rate/divider,
            "term": term,
            "payable": payable,
            "noOfPayments": term*divider,
            "principal": 0
        };

        var i = TLPCalculations.monthlyRate/100;
        var n = TLPCalculations.noOfPayments;
        TLPCalculations.principal =  TLPCalculations.monthlyDebtCapacity/(i+(i/(Math.pow(1+i, n)-1)))
        
        _default_config.headers = ['loan_info_param', ''];
        _default_config.data = [
            {
                loan_info_param: 'Annual Debt Capacity',
                '': initScript.separateNumberByCommaAndRoundOffwithSign(TLPCalculations.annualDebtCapacity)
            },
            {
                loan_info_param: 'Monthly Debt Capacity',
                '': initScript.separateNumberByCommaAndRoundOffwithSign(TLPCalculations.monthlyDebtCapacity)
            },
            {
                loan_info_param: 'Annual Interest Rate',
                '': TLPCalculations.annualRate.toFixed(2)+"%"+"&nbsp;&#9998;"
            },
            {
                loan_info_param: 'Term (In years)',
                '': TLPCalculations.term+"&nbsp;&#9998;"
            },
            {
                loan_info_param: 'Payable',
                '': TLPCalculations.payable+"&nbsp;&#9998;"
            },
            {
                loan_info_param: 'Principal',
                '': initScript.separateNumberByCommaAndRoundOffwithSign(TLPCalculations.principal)
            }
        ];

        _default_config.table_divs = _default_config.TLPCalculations.table_divs;
        _default_config.data = templateUtil.getColumnWiseData(_default_config.data, _default_config.headers);
        _default_config.table_divs[0].columns = _default_config.headers;
        _default_config.columns = _default_config.TLPCalculations.columns;
        // templateUtil.appendTabelHeaders(_default_config);
        templateUtil.appendTabelRows(_default_config);
    }
    
    /**
     * clearEditmode : Refresh TLP calculations between events
     * @author Ahmad Zaman
     */
    function clearEditmode(){
        $(".editableValue").removeClass("editmode")
        $(".TLPCalculationsRow").html("");        
        appendTLPCalculationsHTML()   
    }

    /**
      * Event: mouseenter
      * Target: .editableValue
      * Purpose: Enable pointer cursor for editable values
      * @author Ahmad Zaman
    */
    $(document).on("mouseenter", ".editableValue", function(e){
        var entity = $(this).prev().html();
        if("Term (In years)" == entity || "Annual Interest Rate" == entity || "Payable" == entity){
            $(this).css("cursor", "pointer")
        }
    })

    /**
      * Event: click
      * Target: .editableValue
      * Purpose: Enable editmode for Interactive Term loan princial calculations
      * @author Ahmad Zaman
    */
    $(document).on("click", ".editableValue", function(e){
        //Toggle dropdown
        if($(this).hasClass("editmode")){
            if($(e.target).hasClass("editableValue")){
                clearEditmode()
            }
            return
        }
        else {
            // Show validation message if editmode already active for any other value
            if($(".editableValue").hasClass("editmode")){
                if($('.editmode').find('p.TLPerror').length === 0)
                    $(".editmode").append("<p class=\"TLPerror\" style=\"color:red;\">Please select value</p>")
                return
            }
            //Open editmode for selected value
            $(this).addClass("editmode")
        }

        //Enable editable value's dropdowns
        var entity = $(this).prev().html();
        if("Term (In years)" == entity){
            var opts = '<option value="0.5">6 Months</option>'
            for(var i = 1; i<=30; i++) opts += `<option value="${i}">${i} Year${(i==1)?"":"s"}</option>`
            $(this).html('<select class="termEditable custom-select" style="width:75%">'+opts+'</select>&nbsp;&#10060;')
            $(".termEditable").val(_default_config.TLPDefaults.term)
        }
        else if("Annual Interest Rate" == entity){
            var opts = ""
            for(var i = 0.25; i<=20; i=i+0.25)
                opts += `<option value="${i}">${i.toFixed(2)} %</option>`
            $(this).html('<select class="rateEditable custom-select" style="width:75%">'+opts+'</select>&nbsp;&#10060;')
            $(".rateEditable").val(_default_config.TLPDefaults.rate)
        }
        else if("Payable" == entity){
            var selectOpts = ["Daily", "Weekly", "Bi-weekly", "Monthly"], opts = "";
            for(var i = 0; i<selectOpts.length; i++){
                opts += '<option value="'+selectOpts[i]+'">'+selectOpts[i]+'</option>'
            }
            $(this).html('<select class="payableEditable custom-select" style="width:75%">'+opts+'</select>&nbsp;&#10060;')
            $(".payableEditable").val(_default_config.TLPDefaults.payable)
        }
    });

    /**
      * Event: change
      * Target: .termEditable && .rateEditable && .payableEditable
      * Purpose: Handle change events for TLP calculation's editable values
      * @author Ahmad Zaman
    */
    $(document).on("change", ".termEditable", function(){
        _default_config.TLPDefaults.term = $(this).val();
        clearEditmode()
    })
    $(document).on("change", ".rateEditable", function(){
        _default_config.TLPDefaults.rate = parseFloat($(this).val());
        clearEditmode()
    })
    $(document).on("change", ".payableEditable", function(){
        _default_config.TLPDefaults.payable = $(this).val();
        clearEditmode()
    })


    const initRangeBar = () => {
        slider1 = new Slider('#ebitdaSlider1', {
            formatter: function(value) {
                return value;
            },
            tooltip: 'always',
            useCurrentValue: true
        }).on('change', currentSafetyMarginRatio);

        slider2 = new Slider('#ebitdaSlider2', {
            formatter: function(value) {
                return value;
            },
            tooltip: 'always'
        }).on('change', additionalSafetyMarginRatio);
    };


    const loadChart = () => {
        clearElements();
        let operatingProfit = _default_config.est_operating_profit_object[_default_config.selected_option];
        // let operatingProfit = _default_config["operating_profit"][_default_config.selected_option]
        _default_config.operating_expense = _default_config.revenue[_default_config.selected_option] - operatingProfit;
        
        _default_config.current_debt_chart_config = {
            id: ".ebitdaLeftGraph",
            width: initScript.getHTMLElementByDelimiter("ebitdaLeftGraph").width(),
            margin: { top: 20, right: 30, bottom: 30, left: 60 },
            height: 400,
            neg_y_axis: (operatingProfit < 0 ) ? true : false,
            data: [
                {
                    "name": "Revenue",
                    "value": initScript.roundOff(_default_config.revenue[_default_config.selected_option]),
                    "class": "revenue_rect",
                    "start": 0,
                    "end": Math.abs(_default_config.revenue[_default_config.selected_option]),
                },
                {
                    "name": "Operating Costs",
                    "value": initScript.roundOff(_default_config.operating_expense),
                    "class": "operating_expense_rect",
                    // "start": 0,
                    "start": (operatingProfit < 0)? 0 : Math.abs(_default_config["operating_profit"][_default_config.selected_option]),
                    // "end": Math.abs(_default_config.operating_expense),
                    "end": (operatingProfit < 0)? Math.abs(_default_config.operating_expense) :Math.abs(_default_config.revenue[_default_config.selected_option])
                },
                {
                    "name": "Operating Profit",
                    "value": (operatingProfit >= 0)?initScript.roundOff(_default_config["operating_profit"][_default_config.selected_option]):-1*initScript.roundOff(_default_config["operating_profit"][_default_config.selected_option]),
                    "class": "est_operating_profit_rect",
                    // "start": Math.abs(_default_config.operating_expense),
                    "start": 0,
                    "end": (operatingProfit < 0)? operatingProfit : Math.abs(_default_config["operating_profit"][_default_config.selected_option]),
                },
            ]
        };
        charts.waterfall.init(_default_config.current_debt_chart_config);
        loadFutureDebtChart();
    };

    /**
     * loadFutureDebtChart : loading waterfall chart
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function loadFutureDebtChart(flag = false) {
        let operatingProfit = _default_config.est_operating_profit_object[_default_config.selected_option];
        // let operatingProfit = _default_config["operating_profit"][_default_config.selected_option]
        _default_config.operating_expense = _default_config.revenue[_default_config.selected_option] - operatingProfit;

        const est_operating_profit = initScript.roundOff(_default_config["operating_profit"][_default_config.selected_option]);
        const current_debt = initScript.roundOff(Math.max(0, _default_config["debt"][_default_config.selected_option]));
        // const current_debt = initScript.roundOff(Math.max(0, _default_config.current_debt));
        const current_debt_value = initScript.roundOff(current_debt * _default_config.current_range_value);
        const current_debt_margin = initScript.roundOff(current_debt * _default_config.current_range_value - current_debt);
        var future_debt = initScript.roundOff(_default_config.future_debt = est_operating_profit - current_debt - current_debt_margin);
        var future_debt_value = initScript.roundOff((est_operating_profit - current_debt - current_debt_margin) / (_default_config.additional_range_value || 1));
        var future_debt_margin = initScript.roundOff(future_debt - future_debt_value);

        if( (current_debt+current_debt_margin) > operatingProfit){
            future_debt = 0;
            future_debt_value = 0;
            future_debt_margin = 0;
        }

        if(_default_config.selected_option == _default_config.quarter_filter_option[3]){
            updateDSCR(initScript.roundOff(future_debt_value))
            // updateDSCR(initScript.roundOff(_default_config.future_debt));
        }

        const chart_config_with_abs = {
            current_debt: Math.abs(current_debt),
            est_operating_profit: Math.abs(est_operating_profit),
            current_debt_margin: Math.abs(current_debt_margin),
            current_debt_value: Math.abs(current_debt_value),
            current_debt_margin_start: ((future_debt_value < 0)? 0: Math.abs(future_debt_value)) + ((future_debt_value < 0)? 0: Math.abs(future_debt_margin)) + Math.abs(current_debt),
            current_debt_margin_end: ((future_debt_value < 0)? 0: Math.abs(future_debt_value)) + ((future_debt_value < 0)? 0: Math.abs(future_debt_margin)) + Math.abs(current_debt) + Math.abs(current_debt_margin),
            future_debt: Math.abs(future_debt),
            future_debt_value: Math.abs(future_debt_value),
            future_debt_margin: Math.abs(future_debt_margin),
            future_debt_margin_end: Math.abs(current_debt) + Math.abs(current_debt_margin) + Math.abs(future_debt_value) + Math.abs(future_debt_margin),
            future_debt_margin_start: Math.abs(current_debt) + Math.abs(current_debt_margin) + Math.abs(future_debt_value)
        };
        if(_default_config.selected_option == _default_config.quarter_filter_option[3]){
        initScript.getHTMLElementByDom("debtAmount", "#").value = future_debt_value; //_default_config.future_debt;
        initScript.getHTMLElementByDom("debtAmount", "#").setAttribute("value", future_debt_value); //_default_config.future_debt);
        }
        _default_config.future_debt_chart_config = {
            id: ".ebitdaRightGraph",
            "is_fixed_axis": true,
            width: initScript.getHTMLElementByDelimiter("ebitdaRightGraph").width(),
            margin: { top: 20, right: 30, bottom: 30, left: 60 },
            neg_y_axis: true,
            height: 300,
            data: [
                {
                    "name": "Operating Profit",
                    "value": (operatingProfit >= 0)?est_operating_profit: -1*est_operating_profit,
                    "class": "est_operating_profit_rect1",
                    "start": 0,
                    "end": chart_config_with_abs.est_operating_profit,
                },
                {
                    "name": "Current Debt Capacity",
                    "value": current_debt,
                    "class": "current_debt_rect",
                    // "start": 0,
                    // "end": chart_config_with_abs.current_debt,
                    "start": (future_debt_value < 0) ? 0 : chart_config_with_abs.future_debt_value + ((future_debt_margin < 0)?0:chart_config_with_abs.future_debt_margin),
                    "end": chart_config_with_abs.current_debt_margin_start
                },
                {
                    "name": "Future Debt Capacity",
                    "value": future_debt_value,
                    "class": "future_debt_rect_" + (future_debt_value >= 0 ? "positive" : "negative") + "_values future_debt_rect",
                    // "start": (future_debt_value < 0) ? 0 : chart_config_with_abs.current_debt + chart_config_with_abs.current_debt_margin,
                    // "end": (future_debt_value < 0) ? -1 * chart_config_with_abs.future_debt_value : chart_config_with_abs.future_debt_margin_end,
                    "start": 0,
                    "end": (future_debt_value < 0) ? -1 * chart_config_with_abs.future_debt_value : (chart_config_with_abs.future_debt_margin_start - Math.abs(current_debt) - Math.abs(current_debt_margin))
                },
                {
                    "name": "",
                    "value": current_debt_margin,
                    "class": "margin_current_debt_rect",
                    // "start": chart_config_with_abs.current_debt,
                    // "end": chart_config_with_abs.current_debt + chart_config_with_abs.current_debt_margin,
                    // "parent": 1,
                    "start": (current_debt_margin < 0)? -1 * (chart_config_with_abs.current_debt_value) : chart_config_with_abs.current_debt_margin_start,
                    "end": (current_debt_margin < 0)? -1 * (chart_config_with_abs.current_debt) : chart_config_with_abs.current_debt_margin_end,
                    "parent": 3
                },
                {
                    "name": "",
                    "value": future_debt_margin,
                    "class": "margin_future_debt_rect",
                    // "start": future_debt_margin < 0 ? -1 * chart_config_with_abs.future_debt_value : chart_config_with_abs.future_debt_margin_start,
                    // "end": future_debt_margin < 0 ? -1 * chart_config_with_abs.future_debt : chart_config_with_abs.future_debt_margin_end,
                    "parent": 2,
                    "start": future_debt_margin < 0 ? -1 * chart_config_with_abs.future_debt_value : (chart_config_with_abs.future_debt_margin_start - Math.abs(current_debt) - Math.abs(current_debt_margin)),
                    "end": future_debt_margin < 0 ? -1 * chart_config_with_abs.future_debt : (chart_config_with_abs.future_debt_margin_end - Math.abs(current_debt) - Math.abs(current_debt_margin))
                }
            ]
        };
        if( 0 > operatingProfit){
            _default_config.future_debt_chart_config.data = []
        }
        charts.waterfall.init(_default_config.future_debt_chart_config);
        analyserV2.resolvePromise();
    }

    /**
     * currentSafetyMarginRatio : html event
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     */

    function currentSafetyMarginRatio(event) {
        _default_config.current_range_value = Number(event.newValue);
        clearRightChartElements();
        loadFutureDebtChart();
        clearEditmode();
    }

    /**
     * updateDSCR : update dscr calculation
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param value number
     */

    function updateDSCR(value) {
        if (isNaN(value)) value = +value.target.value;
        value = _default_config["est_operating_profit_object"][_default_config.selected_option] / ((_default_config.current_debt + value) || 1);
        // value = _default_config["operating_profit"][_default_config.selected_option] / ((_default_config.current_debt) || 1);
        document.getElementById("updatedDSCR").value =  value.toFixed(2);
        initScript.getHTMLElementByDom("updatedDSCR", "#").setAttribute("value", value.toFixed(2));
    }

    /**
     * typeCastedValue : html event
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param val
     */

    const typeCastedValue = val =>  Number((Math.abs(val)).toFixed(2));

    /**
     * additionalSafetyMarginRatio : clearing html
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param event object
     */

    function additionalSafetyMarginRatio(event) {
        _default_config.additional_range_value = Number(event.newValue);
        clearRightChartElements();
        loadFutureDebtChart(true);
        clearEditmode()
    }

    /**
     * clearElements : html event
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function clearElements() {
        initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter("ebitdaLeftGraph"), "");
        initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter("ebitdaRightGraph"), "");
    }

    /**
     * clearRightChartElements : html event
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function clearRightChartElements() {
        initScript.innerHTMLToATarget(initScript.getHTMLElementByDelimiter("ebitdaRightGraph"), "");
    }

    /**
     * getSelectedValue : returning selected value
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    function getSelectedValue(event) {
        _default_config.selected_option = event.target.value;
        if (_default_config.selected_option === _default_config.current_selected_option) return;
        _default_config.current_selected_option = _default_config.selected_option;
        loadChart();
    }

    /**
     * setDefaultDSCR : setting up default dscr calculation
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     */

    const setDefaultDSCR = event => {
        clearRightChartElements();
        slider1.refresh({ useCurrentValue: _default_config.slider.min_value });
        slider1.on('change', currentSafetyMarginRatio);

        slider2.refresh({ useCurrentValue: _default_config.slider.min_value });
        slider2.on('change', additionalSafetyMarginRatio);

        _default_config.current_range_value = _default_config.slider.min_value;
        _default_config.additional_range_value = _default_config.slider.min_value;
        loadFutureDebtChart(true);
    };

    const hideShowSectionsOverride = t => {
        clearRightChartElements();
        -1 !== t.target.href.search("table") ? (initScript.getHTMLElementByDelimiter("hideShowSection2").css("display", "block"), initScript.getHTMLElementByDelimiter("hideShowSection1").css("display", "none"), initScript.getHTMLElementByDelimiter("sortByMonthOption").css("display", "none")) : (initScript.getHTMLElementByDelimiter("hideShowSection2").css("display", "none"), initScript.getHTMLElementByDelimiter("hideShowSection1").css("display", "block"), initScript.getHTMLElementByDelimiter("sortByMonthOption").css("display", "inherit"))
        loadFutureDebtChart(true);
    }

    return {
        init,
        currentSafetyMarginRatio,
        additionalSafetyMarginRatio,
        getSelectedValue,
        setDefaultDSCR,
        updateDSCR,
        hideShowSectionsOverride
    };
})();
